module.exports = __webpack_public_path__ + "static/media/correct.a908145b.png";